import { isValidElement } from 'react';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Notifications from 'app/main/notifications/Notifications';
import { PATHS as BILLING_PATHS } from 'app/main/billing/constants';
import { PERMISSIONS } from 'app/main/teams/constants/permissions';
import UserMenu from 'app/theme-layouts/shared-components/UserMenu';
import PermissionsGate from 'app/main/teams/components/PermissionsGate';
import SwitchStatusApplication from 'app/theme-layouts/shared-components/SwitchStatusApplication';

const HIDE_MODE_SWITCH_PATHS = [BILLING_PATHS.BILLING];

export default function DefaultHeaderContent({ content: Content }) {
  const { pathname } = useLocation();

  if (Content && typeof Content === 'function' && isValidElement(<Content />)) {
    return <Content />;
  }

  const showModeSwitch = !HIDE_MODE_SWITCH_PATHS.some((path) => pathname.startsWith(path));

  return (
    <Box display="flex" gap="20px" alignItems="center">
      {showModeSwitch && (
        <PermissionsGate scopesExclude={[PERMISSIONS.OnlyTestMode.value]}>
          <SwitchStatusApplication />
        </PermissionsGate>
      )}
      <Notifications />
      <UserMenu />
    </Box>
  );
}
